import { inject, Pipe, type PipeTransform } from '@angular/core';
import { UserDataService } from 'src/app/services/user-data/user-data.service';

@Pipe({
	name: 'dateTimeFormat',
})
export class DateTimeFormatPipe implements PipeTransform {
	private userDataService = inject(UserDataService);

	/**
	 * Transforms a given date into a formatted string based on the provided locale and options.
	 *
	 * @param date - The date to be transformed. Can be a Date object, a string representation of a date, or undefined.
	 * @param locale - The locale to be used for formatting the date. If not provided, the user's language from the userDataService will be used.
	 * @param options - Additional options to be passed to the Intl.DateTimeFormat constructor.
	 * @returns The formatted date string or undefined if the input date is undefined.
	 */
	transform(
		date: Date | string | undefined,
		locale?: string,
		options?: Intl.LocaleOptions,
	): string | undefined {
		if (!date) return;

		const scopedLocale = locale ? locale : this.userDataService.getUserLanguage();
		const providedDate = typeof date === 'string' ? new Date(date) : date;

		return new Intl.DateTimeFormat(scopedLocale, options).format(providedDate);
	}
}
